import React, { useState } from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { AlertModel } from "../models/AlertModel";
import CustomAlert from "../components/Alert";
import CategoriesTree from "../pages_components/admin/category/CategoriesTree";
import CategoryRightPanel from "../pages_components/admin/category/CategoryRightPanel";
import NewsEdit from "../pages_components/admin/news/NewsEdit";
import { ICategory } from "../models/ICategory";

export default function AdminPage() {

    const emptyAlert: AlertModel = { show: false, message: "", variant: 'success' };
    const [alert, setAlert] = useState<AlertModel>(emptyAlert);
    const [selectedCategory, setSelectedCategory] = useState<ICategory | null>(null);

    function onCloseAlert() {
        setAlert(emptyAlert)
    }

    function setErrorAlert(message: string) {
        setAlert({ show: true, message: message, variant: 'danger' });
    }

    return (
        <Container className="page-container">
            <Tabs
                defaultActiveKey="categories_edit"
                className="mb-3">
                <Tab eventKey="categories_edit" title="Категории">
                    <Row>
                        <Col lg={4}>
                            <CategoriesTree setErrorAlert={setErrorAlert} onSelectCategory={setSelectedCategory}></CategoriesTree>
                        </Col>
                        <Col style={{ borderLeft: "1px solid #dee2e6" }}>
                            <CategoryRightPanel setErrorAlert={setErrorAlert} selectedCategory={selectedCategory}></CategoryRightPanel>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="news_edit" title="Новости">
                    <NewsEdit setErrorAlert={setErrorAlert}></NewsEdit>
                </Tab>
            </Tabs>


            <CustomAlert variant={alert.variant}
                message={alert.message}
                show={alert.show}
                onClose={onCloseAlert}
                dismissible>
            </CustomAlert>
        </Container>);
}
